import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';

// Page Components
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Vision from './pages/Vision';
import Contact from './pages/Contact';
import Careers from './pages/careers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccountPage from './pages/DeleteAccountPage';
import Products from './pages/Products'; // Import Products page

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} /> {/* Add Products route */}
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
            
            {/* 404 Page */}
            <Route path="*" element={
              <div style={{ 
                padding: '60px 20px', 
                textAlign: 'center',
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <h1 style={{ color: '#2E8B57', marginBottom: '20px' }}>404 - Page Not Found</h1>
                <p style={{ marginBottom: '30px' }}>The page you're looking for doesn't exist.</p>
                <a 
                  href="/" 
                  style={{
                    padding: '12px 24px',
                    backgroundColor: '#2E8B57',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '6px',
                    fontWeight: '500'
                  }}
                >
                  Go to Homepage
                </a>
              </div>
            } />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
